import type { WikiBlock } from "../types";

/** Judgment Selling — 직감 인앱 요약 (SSOT: trait.instinct). */
export const talentInstinctBlocks: readonly WikiBlock[] = [
  {
    type: "callout",
    tone: "info",
    text: "위험하면 머리가 아니라 몸이 먼저 움직입니다. “똑똑한 선택”이 아니라 “얼마나 빨리 피하느냐”입니다.",
  },
  { type: "h2", text: "플레이에서 보이고 싶은 것" },
  {
    type: "ul",
    items: [
      "직감 높음 → 바닥에 위험 표시가 뜨면 바로 몸을 뺀다",
      "직감 낮음 → 피하지 않고 제자리에서 계속 때린다",
      "아주 낮으면 → 위험한 장판이 와도 거의 안 피한다",
      "너무 높으면 → 피하느라 공격·힐을 놓친다",
    ],
  },
  { type: "h2", text: "디자인 의도" },
  {
    type: "ul",
    items: [
      "반사신경에 가깝다. IQ·최적 루트가 아니다",
      "부관(파티 자리 안내)을 따르는지와는 별개다",
      "“어디로 가는 게 좋은가”는 통찰이 본다. 직감은 “지금 빠져나갈까?”만 연다",
      "파티가 살짝 빨라지는 생존 버프는 Soft 생존 바닥(발밑 Soft 위험)이다. 직감 슬라이더로 팔지 않는다",
    ],
  },
  { type: "h2", text: "높이면 / 낮추면" },
  {
    type: "table",
    headers: ["", "높이면", "낮추면"],
    rows: [
      ["좋은 점", "빨리·멀리 피한다", "공격·힐을 더 오래 넣는다"],
      ["나쁜 점", "피하느라 딜·힐을 놓친다", "장판·돌진에 맞고 싸운다"],
      ["한마디", "몸이 산다", "손이 바쁘다"],
    ],
  },
  {
    type: "p",
    text: "딜레이·이탈 거리·≤20/≥80 게이트 식 → Wiki 「재능 계산식」.",
  },
];
